// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b2-3";
export var contentContainer = "_b2-0";
export var editorContainer = "_b2-1";
export var quillInputForm = "_b2-2";
export var zoneDivider = "_b2-4";